import React from 'react';
import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const TickerWrapper = styled.div`
  overflow: hidden;
  background: #FBD891;
  margin-top: 15px;
  padding: 12px 0;
  white-space: nowrap;
`;

const TickerContent = styled.div`
  display: flex;
  width: max-content;
  animation: ${scroll} 20s linear infinite;
`;

const P = styled.span`
  font-size: 13px;
  font-weight: 500;
  margin-right: 50px;

  .color {
    color: #01BC8D;
  }
`;

export const RewardNews = () => {
  const getNumber = () => Math.floor(Math.random() * (400 - 200 + 1)) + 200;

  const messages = Array.from({ length: 10 }, (_, i) => (
    <P key={i}>
      **{6941 + i} has earned a <span className="color">{getNumber()} USDT</span> commission
    </P>
  ));

  return (
    <TickerWrapper>
      <TickerContent>
        {messages}
        {/* {messages /* duplicated for seamless loop */} 
      </TickerContent>
    </TickerWrapper>
  );
};
